import * as THREE from "three";

const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera(60, innerWidth / innerHeight, 1, 1000);
camera.position.set(25, 25, 25);
camera.lookAt(0, 0, 0);

const renderer = new THREE.WebGLRenderer({ antialias: true });
renderer.setSize(innerWidth, innerHeight);
document.body.appendChild(renderer.domElement);


const color = new THREE.Color("#ffffff");


// --- Voxels as instances ---
let size = 3//Math.random() * 1 + 2;
let height = Math.random()*1.25 + 0.25;
let length = 1 * height// Math.random() +0.2;
let shape = Math.random([.5,1,1,2])
let width = shape*height//  Math.random() + 0.2;
const geom = new THREE.BoxGeometry(size*length, size*width, size*height);
let metalness = Math.random() * 1.1;
let roughness = 0.2+1 - metalness; //Math.random() * 1;
// Use MeshStandardMaterial if you want lights; MeshLambert/Phong cheaper; MeshBasic cheapest.
let mat = new THREE.MeshStandardMaterial({ roughness: roughness, metalness: metalness });

let count = 80000; // try 10k-200k depending on GPU
const voxels = new THREE.InstancedMesh(geom, mat, count);
voxels.instanceMatrix.setUsage(THREE.DynamicDrawUsage); // if you plan to update
scene.add(voxels);

// Optional per-instance colors (still 1 draw call)

voxels.instanceColor = new THREE.InstancedBufferAttribute(new Float32Array(count * 3), 3);
let speeds = new Float32Array(count * 3)
const dummy = new THREE.Object3D();
for (let i = 0; i < count; i++) {
    // Example: random cloud
    const x = (Math.random() - 0.5) * 300;
    const y = (Math.random() - 0.5) * 300;
    const z = (Math.random() - 0.5) * 300;
    speeds[i] = Math.random()-0.5;
    dummy.position.set(x, y, z);
    dummy.updateMatrix();
    voxels.setMatrixAt(i, dummy.matrix);

    // color.setHSL((x * 0.01 + 0.5) % 1, 0.7, 0.5);
    voxels.setColorAt(i, color);
}
voxels.instanceMatrix.needsUpdate = true;
voxels.instanceColor.needsUpdate = true;
let distancetolight = Math.random() * 40 + 10;
// // Lights (if using Standard)
// let ambientLight = new THREE.AmbientLight(0xffffff, 10.0);
// scene.add(ambientLight);
let luminosity = Math.random() * .3 + .3;
let intensity = Math.random() * 80 + 10;
let saturation = Math.random() * .5 + .1;
for (let i = 0; i < 20; i++) {
    const light = new THREE.PointLight(0xffffff, intensity);
    light.color.setHSL((Math.random()) * 360, saturation, luminosity);
    light.position.set((Math.random() - 0.5) * distancetolight, (Math.random() - 0.5) * distancetolight, (Math.random() - 0.5) * distancetolight);
    scene.add(light);
}
// scene.add(new THREE.HemisphereLight(0xff2233, 0x222222, 2.0));
// const dir = new THREE.DirectionalLight(0x2233ff, 2.0);
// dir.position.set(10, 20, -10);
// scene.add(dir);

addEventListener("resize", () => {
    camera.aspect = innerWidth / innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(innerWidth, innerHeight);
});
const minX = -300;
const maxX = 300;
const Width = maxX - minX;
let gspeed = 2+Math.random()*10; // units per second

const clock = new THREE.Clock();
function animate() {
    const dt = clock.getDelta();
    let time = 0.3*Date.now();
    for (let i = 0; i < count; i++) {
        voxels.getMatrixAt(i, dummy.matrix);
        dummy.matrix.decompose(dummy.position, dummy.quaternion, dummy.scale);

        dummy.position.x = minX + ((dummy.position.x - minX + gspeed*speeds[i] * dt) % Width);

        dummy.updateMatrix();
        voxels.setMatrixAt(i, dummy.matrix);
    }
   
    voxels.rotation.y = time * 0.00011;
    voxels.rotation.x = time * 0.00012;
    voxels.rotation.z = time * 0.00013;
    voxels.instanceMatrix.needsUpdate = true;
    requestAnimationFrame(animate);
    renderer.render(scene, camera);
}

animate();

document.addEventListener('keydown', (event) => {
    if (event.key === 'r') {
        location.reload();
    }
});